import { Modal, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import RegulationLimits from './regulation/RegulationLimits'
import { EditWhiteIcon, ModalCloseIco } from '@modules/CustomIcons'
import { t } from 'i18next'
import { useForm, FormProvider, useWatch } from 'react-hook-form'
import moment from 'moment'
import { yupResolver } from '@hookform/resolvers/yup'
import { SchemaLimitAdgustment } from '../../../constants/SchecmaLimitAdgustment'
import { useAppSelector } from '@shared/hooks/useAppSelector'
import userGWFragments from '@shared/hooks/usegwFragments'
import { ModalProvider } from '@shared/Modal'
import { LIMIT_ATM } from '../../../constants/constantForLimits'
import { useFetchCardLimitsQuery } from 'store/reducers/limitsforBusinnesCard/cardLimits.api'
import { QueryStatus } from '@reduxjs/toolkit/query'

interface LimitAdgustmentModalProps {
  record: any
}

function LimitAdgustmentModal({ record }: LimitAdgustmentModalProps) {
  const pan = useAppSelector((state) => state.employeePan.pan)
  const { data: limitsInfo } = useFetchCardLimitsQuery(pan, {
    skip: !pan,
    refetchOnMountOrArgChange: false,
  })

  const limitRow = limitsInfo?.limitTypeList?.find(
    (item) => item.type === record.type
  )

  const methods = useForm({
    mode: 'all',
    resolver: yupResolver(SchemaLimitAdgustment),
    defaultValues: {
      toExpDate: false,
      expDate: limitsInfo?.generInfo?.expDate,
      amount: limitRow?.amount?.designated,
      curr: limitsInfo?.generInfo?.accCurr,
      count: limitRow?.count?.designated ?? 99999,
      statusForLabel: limitRow?.general?.status,
      status: 'Redifined',
      pan: limitsInfo?.generInfo?.pan,
      limitType: record.type,
      cif: limitsInfo?.generInfo?.cif,
    },
  })

  const watchCheckBox = useWatch({
    name: 'toExpDate',
    control: methods.control,
  })

  const hasPrevStartValue = !!limitRow?.date
  useEffect(() => {
    if (limitRow?.date && !watchCheckBox) {
      methods.setValue(
        'fromDate',
        moment(limitRow?.date?.fromDate, 'DD.MM.YYYY').format('DD.MM.YYYY')
      )
      methods.setValue(
        'toDate',
        moment(limitRow?.date?.toDate, 'DD.MM.YYYY', 'DD.MM.YYYY').format(
          'DD.MM.YYYY'
        )
      )
    }

    methods.trigger()
  }, [watchCheckBox])

  return (
    <>
      {record.type === LIMIT_ATM && (
        <ModalProvider
          footer={null}
          width={800}
          centered
          title={t('businessCards.adjustmentsLimit')}
          afterClose={() => {
            methods.reset()
          }}
          modalContent={
            <FormProvider {...methods}>
              <RegulationLimits hasPrevStartValue={hasPrevStartValue} />
            </FormProvider>
          }
        >
          {({ openModal }) => (
            <Row
              onClick={() => {
                methods.trigger('amount')
                openModal(QueryStatus.pending)
              }}
              style={{
                width: '28px',
                height: '28px',
                borderRadius: '4px',
                backgroundColor: '#015CD1',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
              }}
            >
              <EditWhiteIcon />
            </Row>
          )}
        </ModalProvider>
      )}
    </>
  )
}

export default LimitAdgustmentModal
